import { ThemeConfig } from 'antd'

export const colorPrimary = '#2f3e2d'

export const theme: ThemeConfig = {
  token: {
    colorPrimary,
    colorPrimaryBg: '#e1e1e1',
    colorInfo: colorPrimary,
    colorSuccess: '#4a8c3e',
    colorWarning: '#e6a443',
    colorError: '#d9544d',
    colorTextBase: '#333333',
    colorBgBase: '#f5f5f5',
  },
  cssVar: true,
}
